import { render } from "./EditPersonalInfo.vue?vue&type=template&id=613d3cba"
import script from "./EditPersonalInfo.vue?vue&type=script&lang=js"
export * from "./EditPersonalInfo.vue?vue&type=script&lang=js"

import "./EditPersonalInfo.vue?vue&type=style&index=0&id=613d3cba&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__